import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Trans } from "react-i18next";
import { getHiddenMetadataValue } from "@modules/metadataFieldManagements";
import HiddenMetadataPermissionConfirmModal from "@components/modals/WarningConfirm";

const useHiddenMetadata = () => {
    const [modal, setModal] = useState(false);
    const dispatch = useDispatch();

    const refineMetadata = (target, metadataSchemaId, metadataFieldId, data) => {
        return target.map((v) => {
            if (v.id === metadataSchemaId) {
                const fields = v.fields.map((f) => {
                    if (f.id === metadataFieldId) {
                        return {
                            ...f,
                            ...data,
                        };
                    } else {
                        return f;
                    }
                });
                return {
                    ...v,
                    fields,
                };
            } else {
                return v;
            }
        });
    };

    const getHiddenFieldValuePending = ({ metadataSchemas, metadataSchemaId, fieldId }) => {
        return refineMetadata(metadataSchemas, metadataSchemaId, fieldId, {
            pending: true,
            error: false,
        });
    };

    const getHiddenFieldValueSuccess = ({ metadataSchemas, metadataSchemaId, fieldId, data }) => {
        return refineMetadata(metadataSchemas, metadataSchemaId, fieldId, {
            pending: false,
            error: false,
            value: data.value,
            values: data.values,
            isCheckHiddenValue: true,
        });
    };

    const getHiddenFieldValueFailure = ({ metadataSchemas, metadataSchemaId, fieldId, error }) => {
        setModal(true);
        return refineMetadata(metadataSchemas, metadataSchemaId, fieldId, {
            pending: false,
            error,
            isCheckHiddenValue: false,
        });
    };

    const getHiddenFieldInitialValue = ({ metadataSchemas, metadataSchemaId, fieldId }) => {
        return refineMetadata(metadataSchemas, metadataSchemaId, fieldId, {
            pending: false,
            error: false,
            value: "",
            values: [],
            isCheckHiddenValue: true,
        });
    };

    const renderHiddenMetadataPermissionMessage = () => {
        return (
            <React.Fragment>
                <Trans i18nKey="common::msg::You do not have permission to Show Hidden Metadata." />
                <br />
                <Trans i18nKey="common::msg::If you to Show Hidden Metadata, please ask your administration." />
            </React.Fragment>
        );
    };

    const onClickCloseModal = () => {
        setModal(false);
    };

    const renderHiddenMetadataPermissionConfirmModal = useCallback(() => {
        if (modal)
            return (
                <HiddenMetadataPermissionConfirmModal
                    onClickConfirm={onClickCloseModal}
                    renderMessage={renderHiddenMetadataPermissionMessage}
                />
            );
        else return null;
    }, [modal]);

    return {
        getHiddenMetadataValue,
        getHiddenFieldValuePending,
        getHiddenFieldValueSuccess,
        getHiddenFieldValueFailure,
        getHiddenFieldInitialValue,
        renderHiddenMetadataPermissionConfirmModal,
    };
};

export default useHiddenMetadata;
